import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { SITES_ACTIONS } from '../actions/sites.actions';
import { SitesService } from '../../services/sites.service';

@Injectable()
export class SitesEffects {
  constructor(
    private readonly actions: Actions,
    private readonly sitesService: SitesService,
  ) {}

  getAllSites$ = createEffect(() =>
    this.actions.pipe(
      ofType(SITES_ACTIONS.getAllSites),
      switchMap(() => this.sitesService.getAllSites()),
      map((sites) => SITES_ACTIONS.getSitesSuccess(sites)),
      catchError((err: Error) => of(SITES_ACTIONS.getSitesError(err))),
    ),
  );
}
